import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';

import { prepareSearchParams } from "@/libs/helper";

const resource = `${Config.basePath}/chat-agents`

export default {
  list(payload) {
    return Client.get(resource, {
      params: prepareSearchParams(payload),
    });
  },
  show() {
    return Client.get(`${resource}`)
  },
  create(payload) {
    return Client.post(`${resource}`, payload)
  },
  update(id, payload) {
    return Client.put(`${resource}/${id}`, payload)
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`)
  },
  getStepTemplate() {
    return Client.get(`${resource}/template`, {
      noCamelizeKey: true,
    })
  },
}
